import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class PaymentCompletedHost extends Component {
	static propTypes = {
		content: PropTypes.shape({
			hostName: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			threadId: PropTypes.number.isRequired,
		}).isRequired
	};

	render() {
		const { content: { hostName, guestName, listTitle, threadId, logo, siteName, checkIn, checkOut, confirmationCode } } = this.props;
		let contactURL, checkInDate, checkOutDate
		contactURL = url + '/message/' + threadId + '/host';
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : ''
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<EmptySpace height={20} />
					<div style={fontWeightBold}>
						Bonjour {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						Bonne nouvelle ! {guestName} a effectué son paiement pour la réservation à {listTitle} (Confirmation : {confirmationCode}).
					</div>
					<EmptySpace height={20} />
					<div>
						<strong>Détails de la réservation :</strong>
					</div>
					<div>
						Arrivée : {checkInDate}
					</div>
					<div>
						Départ : {checkOutDate}
					</div>
					<EmptySpace height={20} />
					<div>
						La réservation est maintenant entièrement confirmée et vous pouvez attendre votre voyageur à la date d'arrivée. Vous pouvez le contacter si vous avez des informations supplémentaires à partager.
					</div>
					<div>
						<a style={linkText} href={contactURL}>Contacter le voyageur</a>
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default PaymentCompletedHost;